exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-finisher-component .modal-header{padding:1rem 2rem}.modal-finisher-component .modal-header .title{font-size:26px}.modal-finisher-component .modal-card-body{padding-top:0}.modal-finisher-component .modal-card-body .field{margin-top:.8rem}.modal-finisher-component .content-btns{margin-top:1.4rem;text-align:right}", ""]);

// exports
